export { Chip } from './Chip';
export type { ChipProps, ChipSize, ChipVariant } from './types';
